import { useEffect } from 'react'
import { refreshTokens } from '../services/TokenRefresh'
import { updateSocketAccessToken } from '../services/SocketAuthService'
import { getRefreshToken, saveTokens } from '../services/TokenService'
import { isProduction } from '../utils/constantes'

const KEEP_ALIVE_INTERVAL_MS = 5 * 60 * 1000

export const useSessionKeepAlive = (enabled) => {
  useEffect(() => {
    if (!enabled || !getRefreshToken()) return

    let isMounted = true
    let isRefreshing = false

    const keepAlive = async () => {
      if (isRefreshing || !getRefreshToken()) return

      isRefreshing = true
      try {
        const response = await refreshTokens({ silent: true })
        if (!isMounted) return

        if (response?.status === 200) {
          const tokenObj = response.data
          saveTokens(tokenObj)
          updateSocketAccessToken(tokenObj?.access_token)
          !isProduction && console.log('[SessionKeepAlive] Token refreshed')
        } else if (!isProduction) {
          console.warn('[SessionKeepAlive] Token refresh failed', response?.status)
        }
      } catch (error) {
        if (!isProduction) {
          console.warn('[SessionKeepAlive] Token refresh failed', error)
        }
      } finally {
        isRefreshing = false
      }
    }

    keepAlive()
    const intervalId = setInterval(keepAlive, KEEP_ALIVE_INTERVAL_MS)

    return () => {
      isMounted = false
      clearInterval(intervalId)
    }
  }, [enabled])
}
